// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".view30designs[data-v-5b3c5ccb],.view36designs[data-v-5b3c5ccb],.viewtownsdesigns[data-v-5b3c5ccb]{cursor:pointer}.st0[data-v-5b3c5ccb]{fill:#d52b3b}.st1[data-v-5b3c5ccb]{fill:#fff}.st2[data-v-5b3c5ccb]{fill:#231f20}", ""]);
// Exports
module.exports = exports;
